import { all } from "redux-saga/effects";
import { dashboardSaga } from "./DashboardSaga";

// all sagas
import { loginSaga } from './LoginSaga';
import { mastersSaga } from "./MasterSaga";

function* rootSaga() {
    yield all([
        loginSaga(), 
        mastersSaga(), 
        dashboardSaga(),        
    ])
}

export default rootSaga;
